import { OAuthCredential } from 'mbs-ui-shared';
import { TokenData } from 'mbs-ui-shared@models/auth-models';
import getAdaptedCredentials from 'mbs-ui-shared@utils/credentials';
import { EMPTY, of, OperatorFunction, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export function handleLoginRequest(tfaCallback?: (error: any) => void): OperatorFunction<TokenData, OAuthCredential> {
  return (source$) =>
    source$.pipe(
      switchMap((result) => {
        if (!result.isSuccess) {
          return throwError(() => result.error);
        }
        return of(getAdaptedCredentials(result));
      }),
      catchError((error) => {
        if (error.status === 420) {
          tfaCallback(error.error);
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
}
